import { DOCUMENT, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ContactUsDialogService } from '../../contact-us-dialog.service';
import { Subject, filter, firstValueFrom, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadScript } from '../../load-script.func';
declare let grecaptcha: any
const key = '6LfSBvwoAAAAAJQfzRZAXAZ6Z9JJrWWLxSHTZLtL'

interface ContactFormValues {
  name: FormControl<string | null>;
  company: FormControl<string | null>;
  email: FormControl<string | null>;
  message: FormControl<string | null>;
}


@Component({
    imports: [NgIf, ReactiveFormsModule],
    selector: 'in2-contact-us-form',
    templateUrl: './contact-us-form.component.html',
    styleUrls: ['./contact-us-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsFormComponent implements OnInit, OnDestroy {
  private doc: Document = inject(DOCUMENT)

  @HostBinding('class')
  class = 'text-container w-full md:p-12 bg-white'
  submitting = signal(false)
  submitted = signal(false)
  destroy$ = new Subject<void>();

  dialogService = inject(ContactUsDialogService)

  form = new FormGroup<ContactFormValues>({
    name: new FormControl('', [Validators.required]),
    company: new FormControl('', []),
    email: new FormControl('', [Validators.required, Validators.email]),
    message: new FormControl('', [Validators.required]),
  });

  async ngOnInit() {

    try {
      loadRecaptchaScript(this.doc, key)
    } catch (error) {
      console.error(error);
    }

    this.dialogService.events.pipe(
      takeUntil(this.destroy$),
      filter(e => e === 'closed')).subscribe(() => {
        this.ngOnDestroy()
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.submitted.set(false)
  }

  private readonly http = inject(HttpClient)
  async submit(e: any) {
    if (this.form.invalid) return;
    this.submitting.set(true)

    e.preventDefault();
    try {
      try {
        await loadRecaptchaScript(this.doc, key)
      } catch (error) {
        console.error(error);
      }

      grecaptcha.execute(key,
        { action: 'submit' }
      ).then(async (token: any) => {

        try {
          const res = await firstValueFrom(this.http.post<{ sent: boolean, message: string }>('/contact-us', this.form.value, {
            headers: { 'g-recaptcha-response': token }
          }))
          if (res.sent === true) {
            this.submitting.set(false)
            this.submitted.set(true)
            this.form.reset();
          }
        } catch (error) {
          this.submitting.set(false)
        }
      }).catch((error: any) => {
        this.submitting.set(false)
      });
    } catch (error) {
      console.error(error);
    }
  }

}


let loaded = false
function loadRecaptchaScript(doc: any, key: string): Promise<boolean> {
  if (loaded) return Promise.resolve(true)
  return loadScript(doc, `https://www.google.com/recaptcha/api.js?render=${key}`).then(() => {
    loaded = true
    return true
  })

}